import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'whatsAppParamsConverter',
  standalone: true,
})
export class WhatsAppParamsConverter implements PipeTransform {
  transform(value: string): object {
    const decoded = atob(value);
    const urlParams = new URLSearchParams(decoded);
    return this.paramsToObject(urlParams);
  }

  paramsToObject(entries: URLSearchParams): object {
    const result: Record<string, string | number> = {};
    entries.forEach((value, key) => {
      if (!isNaN(Number(value))) {
        result[key] = parseInt(value);
      } else {
        result[key] = value.replace('+', ' ');
      }
    });

    return result;
  }
}
